import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import store from '@/store'

/* cookie */
import cookie from 'js-cookie'

const instance = axios.create({
  // baseURL: 'http://www.istopcc.com/bid-fe-api'
  baseURL: process.env.VUE_APP_API_URL
})

// 添加请求拦截器
instance.interceptors.request.use(function(config) {
  // 在发送请求之前做些什么
  const token = cookie.get('web-token')
  if (token) {
    config.headers.token = token
  }

  return config
}, function(error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
instance.interceptors.response.use(function(response) {
  // 对响应数据做点什么
  const { code } = response.data

  if (code === 200) {
    return response.data
  } else {
    switch (code) {
      case 401: // token过期
        store.dispatch('logout')

        router.push({
          name: 'login'
        })

        return Vue.prototype.$message.error(response.data.message)
        break
    }

    return Promise.reject(response.data)
  }
}, function(error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})

export default instance
